import { SimpleTenant } from "src/api/generated/frontend_internal_v1";
import React from "react";

/** Data provided by the {@link SINGLE_TENANT_CONTEXT} */
export type SingleTenantContext = {
    /** The currently available tenant */
    tenant: SimpleTenant;

    /** Reload the tenant's information' */
    reset: () => Promise<void>;
};

const SINGLE_TENANT_CONTEXT = React.createContext<SingleTenantContext>({
    tenant: {
        uuid: "",
        name: "",
        description: "",
        badge_name: "",
        badge_color: "Blue",
    },

    /**
     * Reset the tenant
     *
     * @returns a resolved promise
     */
    reset: () => Promise.resolve(),
});
SINGLE_TENANT_CONTEXT.displayName = "SingleTenant";
export default SINGLE_TENANT_CONTEXT;
